
import { createMiddleware } from '@shared/redux';
import { PLATFORMS } from '@domain/platform';
import { editUserConfig, getUserConfigData } from '@domain/user-config';
import { LIST_DOCUMENTS_SET } from './trakto.state';

export const traktoMiddleware = createMiddleware({
    [LIST_DOCUMENTS_SET]: (state, action) => {
        const { documents } = action.payload;
        const userConfig = getUserConfigData(state);
        const showTraktoOnboardingModal = userConfig
            .PARTNERSHIPS?.ONBOARDING_MODAL?.[PLATFORMS.TRAKTO.value] || false;
        const hasDocuments = documents?.length > 0;

        if (hasDocuments && !showTraktoOnboardingModal) {
            const newUserConfig = {
                configs: {
                    PARTNERSHIPS: {
                        ONBOARDING_MODAL: {
                            ...userConfig?.PARTNERSHIPS?.ONBOARDING_MODAL,
                            [PLATFORMS.TRAKTO.value]: hasDocuments,
                        },
                    },
                },
            };

            return editUserConfig(newUserConfig);
        }
        return [];
    },
});
